import { render } from "./navigation.vue?vue&type=template&id=38a8ef1a&scoped=true&ts=true"
import script from "./navigation.vue?vue&type=script&lang=ts"
export * from "./navigation.vue?vue&type=script&lang=ts"

import "./navigation.vue?vue&type=style&index=0&id=38a8ef1a&lang=scss&scoped=true"

import exportComponent from "/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a8ef1a"]])

export default __exports__